import { useEffect, useState } from 'react';
import { fetchProfile, updateProfile, type login } from '../api';

export default function Profile() {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
    town: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  
  useEffect(() => {
    async function loadProfile() {
      try {
        const result = await fetchProfile();
        if (result.ok && result.data) {
          setProfile(result.data);
        }
      } catch (error) {
        console.error('Failed to load profile:', error);
      } finally {
        setLoading(false);
      }
    }
    
    loadProfile();
  }, []);
  
  const handleSave = async () => {
    setSaving(true);
    setSuccess(false);
    
    try {
      const result = await updateProfile(profile);
      if (result.ok) {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      }
    } catch (error) {
      console.error('Failed to save profile:', error);
    } finally {
      setSaving(false);
    }
  };
  
  if (loading) {
    return (
      <div className="px-4 pt-6 pb-24">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ubuntu-green"></div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="px-4 pt-6 pb-24">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
        <p className="text-gray-600 mt-1">Manage your personal information</p>
      </div>
      
      {/* Profile Form */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
          <input
            type="text"
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
            className="input"
            placeholder="Enter your full name"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            value={profile.email}
            onChange={(e) => setProfile({ ...profile, email: e.target.value })}
            className="input"
            placeholder="Enter your email"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
          <input
            type="tel"
            value={profile.phone}
            onChange={(e) => setProfile({ ...profile, phone: e.target.value })}
            className="input"
            placeholder="e.g. 082 123 4567"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Town</label>
          <input
            type="text"
            value={profile.town}
            onChange={(e) => setProfile({ ...profile, town: e.target.value })}
            className="input"
            placeholder="e.g. Senekal, Free State"
          />
        </div>
        
        {success && (
          <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-green-700 text-sm">
            ✅ Profile saved successfully!
          </div>
        )}
        
        <button
          onClick={handleSave}
          disabled={saving}
          className="btn-primary w-full disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Profile'}
        </button>
      </div>
      
      {/* Logout Button */}
      <div className="mt-8">
        <button
          onClick={() => {
            localStorage.removeItem('ubuntu_token');
            window.location.href = '/login';
          }}
          className="w-full text-red-600 font-medium py-3 rounded-xl border border-red-200 active:scale-95 transition-transform"
        >
          Log Out
        </button>
      </div>
    </div>
  );
}
